import {Route, Routes} from "react-router-dom";
import {Navigate} from "react-router";
import Layout from "./Layout";
import {Login} from "./login";

export default function RoutingAuth() {
    return (
        <Layout>
            <Routes>
                <Route path="/"
                       element={<Login />}
                />
                <Route path="/login"
                       element={<Login />}
                />
                <Route
                    path="*"
                    element={<Navigate to="/login" replace />}
                />
            </Routes>
        </Layout>
    );
}
